// This reducer contains data about user's browser (resolution, device type, viewport width, etc.)
import { createAction, createReducer } from '@reduxjs/toolkit';
import { browser } from './helpers/deviceInfo';

// 1. Initial state
const initialState = null;

// 2. Action creators
export const updateBrowserInfo = createAction('listingPage/browser/updateBrowserInfo');

// 3. Reducer
export default createReducer(initialState, {
  [updateBrowserInfo]: () => {
    const device = browser();
    const viewportWidth = Math.max(window.document.documentElement.clientWidth, window.innerWidth || 0);

    return {
      device,
      viewportWidth
    };
  }
});
